import Cookie from "extra/cookie";
import { loadScript } from "extra/functions";
import { startsWithAny, removeStorageEntries } from "extra/storage";
import {
	GTM_ID,
	HOTJAR_ID,
	HOTJAR_SNIPPET_VERSION,
	ANALYTICS_COOKIE_PREFIXES,
	ANALYTICS_STORAGE_PREFIXES,
	GA_STREAM_COOKIE_PREFIX,
	GA_MEASUREMENT_ID_PREFIX,
	GA_DISABLE_FLAG_PREFIX
} from "constants/analytics";

const GTM_SCRIPT_ID = "gtm-script";
const HOTJAR_SCRIPT_ID = "hotjar-script";


const loadGoogleTagManager = () => {
	if ( document.getElementById( GTM_SCRIPT_ID )) return;

	window.dataLayer = window.dataLayer || [];
	window.dataLayer.push({ "gtm.start": new Date().getTime(), event: "gtm.js" });

	loadScript({
		id: GTM_SCRIPT_ID,
		src: `https://www.googletagmanager.com/gtm.js?id=${ GTM_ID }`,
		place: document.head
	});
}


const loadHotjar = () => {
	if ( document.getElementById( HOTJAR_SCRIPT_ID )) return;

	window.hj = window.hj || function () {
		( window.hj.q = window.hj.q || [] ).push( arguments );
	};
	window._hjSettings = { hjid: HOTJAR_ID, hjsv: HOTJAR_SNIPPET_VERSION };

	loadScript({
		id: HOTJAR_SCRIPT_ID,
		src: `https://static.hotjar.com/c/hotjar-${ HOTJAR_ID }.js?sv=${ HOTJAR_SNIPPET_VERSION }`,
		place: document.head
	});
}


export const isAnalyticsLoaded = () => (
	!!document.getElementById( GTM_SCRIPT_ID ) || !!document.getElementById( HOTJAR_SCRIPT_ID )
);


// The opt-out flags may still be set if consent was refused earlier during this page view
const enableGoogleAnalytics = () => {
	Object.keys( window )
		.filter( key => key.indexOf( GA_DISABLE_FLAG_PREFIX ) === 0 )
		.forEach( key => { window[ key ] = false; });
}


export const loadAnalytics = () => {
	enableGoogleAnalytics();
	loadGoogleTagManager();
	loadHotjar();
}


// Analytics cookies may be set on the host or on any parent domain, so each variant has to be removed
const getCookieDomains = () => {
	const parts = window.location.hostname.split(".");
	const domains = [ undefined, window.location.hostname ];

	for ( let i = 0; i < parts.length - 1; i++ ) {
		domains.push( `.${ parts.slice( i ).join(".") }` );
	}

	return domains;
}


// A running Google Analytics tag sends a last hit and writes its cookies again while the page unloads.
// The opt-out flag stops that, and the measurement IDs it needs are taken from the stream cookies.
const disableGoogleAnalytics = cookie_keys => {
	cookie_keys
		.filter( key => key.indexOf( GA_STREAM_COOKIE_PREFIX ) === 0 )
		.forEach( key => {
			const measurement_id = GA_MEASUREMENT_ID_PREFIX + key.slice( GA_STREAM_COOKIE_PREFIX.length );
			window[ GA_DISABLE_FLAG_PREFIX + measurement_id ] = true;
		});
}


export const clearAnalyticsData = () => {
	const domains = getCookieDomains();
	const cookie_keys = Cookie.getAllCookieKeys();

	disableGoogleAnalytics( cookie_keys );

	cookie_keys
		.filter( key => startsWithAny( key, ANALYTICS_COOKIE_PREFIXES ))
		.forEach( key => domains.forEach( domain => Cookie.removeCookie( key, domain )));

	removeStorageEntries( ANALYTICS_STORAGE_PREFIXES );
}
